module.exports = __webpack_public_path__ + "static/media/resetpass-icon.0e8d859a.svg";